// @ts-nocheck
import { ExpandMore } from "@mui/icons-material";
import { Accordion, AccordionDetails, AccordionSummary } from "@mui/material";
import PropTypes from "prop-types";

export default function FileAccordion({
  summary,
  details,
  defaultExpanded,
  expanded,
  onChange,
  odd,
}) {
  return (
    <Accordion
      expanded={expanded}
      onChange={onChange}
      defaultExpanded={defaultExpanded}
      sx={{
        width: "100%",
        backgroundColor: "transparent",
        borderRadius: "14px",
        border: "1px solid rgba(255, 255, 255, 0.3)",
        overflow: "hidden",
      }}
    >
      <AccordionSummary
        expandIcon={
          <ExpandMore
            sx={{
              color: "white",
            }}
          />
        }
        aria-controls="panel1-content"
        id="panel1-header"
        sx={{
          backgroundColor: `${odd ? "rgba(100, 100, 100, 0.2)" : "rgba(255, 255, 255, 0.2)"}`,
        }}
      >
        {summary}
      </AccordionSummary>
      <AccordionDetails
        sx={{
          backgroundColor: "transparent",
        }}
      >
        {details}
      </AccordionDetails>
    </Accordion>
  );
}

FileAccordion.propTypes = {
  summary: PropTypes.node,
  details: PropTypes.node,
  icon: PropTypes.node,
  defaultExpanded: PropTypes.bool,
  expanded: PropTypes.bool,
  onChange: PropTypes.func,
  odd: PropTypes.bool,
};